// extracted by mini-css-extract-plugin
export default {"addToCartControl":"EZ-z","giftCard":"FZ-z","btnContainer":"GZ-z","cartButton":"HZ-z","disabled":"IZ-z"};